module.exports = __webpack_public_path__ + "img/tile-oil1.65200ea0.jpg";